// src/components/Menu.tsx
import { StarIcon, ShoppingBag, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const coffeeProducts = [
  {
    id: 1,
    name: "Ethiopian Yirgacheffe",
    description: "Bright and fruity with notes of citrus and berries. A light-medium roast.",
    price: 18.99,
    image: "https://images.unsplash.com/photo-1511537190424-bbbab87ac5eb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    rating: 4.8,
    reviewCount: 124,
    origins: "Ethiopia",
    roast: "Light-Medium"
  },
  {
    id: 2,
    name: "Colombian Supremo",
    description: "Smooth and balanced with caramel sweetness and nutty undertones.",
    price: 16.99,
    image: "https://images.unsplash.com/photo-1621555828835-28189c0fe6ec?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    rating: 4.7,
    reviewCount: 98,
    origins: "Colombia",
    roast: "Medium"
  },
  {
    id: 3,
    name: "Sumatra Mandheling",
    description: "Earthy and complex with notes of dark chocolate and spices.",
    price: 19.99,
    image: "https://images.unsplash.com/photo-1610889556528-9a770e32642f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    rating: 4.9,
    reviewCount: 86,
    origins: "Indonesia",
    roast: "Medium-Dark"
  },
  {
    id: 4,
    name: "Guatemala Antigua",
    description: "Rich and smooth with chocolate notes and a subtle smoky finish.",
    price: 17.99,
    image: "https://images.unsplash.com/photo-1587734361993-0490df3b3ee8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2036&q=80",
    rating: 4.6,
    reviewCount: 72,
    origins: "Guatemala",
    roast: "Medium"
  }
];

const MenuComponent = () => {
  return (
    <section className="section-padding bg-coffee-100">
      <div className="container-custom">
        <div className="mx-auto max-w-md text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif text-coffee-800 mb-4">Our Coffee Collection</h2>
          <div className="w-16 h-1 bg-coffee-400 mx-auto mb-6"></div>
          <p className="text-coffee-600">
            Savor our handpicked selection of premium single-origin beans and expertly crafted blends, roasted to perfection.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {coffeeProducts.map((product) => (
            <CoffeeCard key={product.id} product={product} />
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/menu" className="btn-primary flex items-center gap-2 mx-auto w-fit">
            Shop Now <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

const CoffeeCard = ({ product }: { product: typeof coffeeProducts[0] }) => {
  return (
    <div className="coffee-card group">
      <div className="relative overflow-hidden">
        <img 
          src={product.image} 
          alt={product.name} 
          className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-4 right-4 bg-white/90 rounded-full px-3 py-1 text-sm font-medium text-coffee-800 flex items-center gap-1">
          <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" />
          {product.rating}
        </div>
      </div>
      <div className="p-5">
        <div className="flex justify-between items-start mb-2">
          <h3 className="font-serif text-lg font-medium text-coffee-800">{product.name}</h3>
          <div className="text-coffee-600 font-medium">${product.price}</div>
        </div>
        <p className="text-coffee-600 text-sm mb-4">{product.description}</p>
        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            <span className="bg-coffee-200 text-coffee-700 text-xs px-2 py-1 rounded-full">
              {product.origins}
            </span>
            <span className="bg-coffee-200 text-coffee-700 text-xs px-2 py-1 rounded-full">
              {product.roast}
            </span>
          </div>
          <button className="rounded-full bg-coffee-600 p-2 text-white hover:bg-coffee-700 transition-colors">
            <ShoppingBag className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuComponent;